export default __webpack_public_path__ + "static/media/delete_white_icon.a59e1482.svg";